import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";

import Box from "@mui/material/Box";
// import Container from '@mui/material/Container';

import {
  formatProviderName,
  isPersonalTrainer
} from "../../helpers/providers";
import { useGetProvidersQuery } from "../../redux/services/providerApi";
import BookingForm from "../../components/booking/BookingFromPublicProviderProfileForm";
import PatientSignupLayout from "../../components/patientSignup/PatientSignupLayout/PatientSignupLayout";

const PublicBookingWithProviderPage = props => {
  const {provider, metaTitle, metaDescription} = props;
  const borderRadius = '16px';
  const boxStyles = {borderRadius, minHeight: '70vh'};
  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name='description'content={metaDescription} />
        {/*<link rel="canonical" href="http://mysite.com/example" />*/}
      </Helmet>
      <PatientSignupLayout 
        {...props} 
        stepTitle={`Schedule a session`}
      >
        <Box 
          style={{
            marginTop: '0em',
            // paddingTop: stepIndex === 0 ? '2em' : '0em',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            borderRadius: borderRadius,
            backgroundColor: '#ffffff',
            border: '1px solid rgb(240,240,240)',
            width: '100%',
          }}
        >
          <BookingForm provider={provider} boxStyles={boxStyles}/>
        </Box>
      </PatientSignupLayout>
    </>
  );
};

PublicBookingWithProviderPage.defaultProps = {
  metaTitle: 'Book a Session with a MovementX Provider',
  metaDescription: 'Schedule your first session with a MovementX provider. Choose from our specialized services and book your appointment today.',
};

const PublicBookingWithProviderPageContainer = props => {
    const {id, slug} = useParams();
    const providerQuery = useGetProvidersQuery(
      (
        slug 
        ? {slug, is_hidden: false} 
        : {id, is_hidden: false}
      ), 
      {refetch: true, skip: false}
    );
    const provider = (providerQuery?.data || [])?.[0] || null;
    const providerName = formatProviderName(provider);
    const city = provider?.primary_location || '';
    const providerType = isPersonalTrainer(provider) ? 'Personal Trainer' : 'Physical Therapist';
    const childProps = {
      provider,
      metaTitle: (
        provider 
        ? `Schedule with ${providerName} - MovementX ${providerType} in ${city}`
        : `Schedule an appointment with ${providerName}, a MovementX ${providerType} in ${city}.`
      ),
      metaDescription: provider ? `Schedule your first session with ${provider.first_name} ${provider.last_name}, a MovementX provider. Choose from our specialized services and book your appointment today.` : 'Schedule your first session with a MovementX provider. Choose from our specialized services and book your appointment today.',
    };
    return <PublicBookingWithProviderPage {...childProps} />;
};

export default PublicBookingWithProviderPageContainer;